import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import IsiActions from './actions';
import Tracking from 'medscape/tracking';
export default class IsiLink{
	constructor(config,$link){
		let el = $link[0];
		$link.off('click.IsiLink').on('click.IsiLink',(e)=>{
			e.preventDefault();
			Tracking.pageLink("isi-link",e.currentTarget);
			IsiActions.linkClick();
		});
	}
}
IsiLink.selector = '[data-module="IsiLink"]';
IsiLink.init = (config,$link) => {
	$link = $link || $(IsiLink.selector);
	if($link.length>0){
		new IsiLink(config,$link);
	}
}




// WEBPACK FOOTER //
// ./src/app/isi/link.js